import togglePanel from '../../shared/toggle-panel.js';

(function (Drupal, drupalSettings, $) {
  Drupal.behaviors.paragraphs = {
    attach: (context, settings) => {
      // Re execute after submit.
      if (context === document.getElementById('awareness-wrapper')) {
        sensibilize();
      }

      if (context === document) {
        if (document.body.getAttribute('data-paragraphs') === 'true') {
          return;
        }
        showMore();

        const paragraphsReadyState = setInterval(() => {
          // BigPipe may cause this block to be called too early, wait for readyState complete.
          if (document.readyState === 'complete') {
            clearInterval(paragraphsReadyState);
            (function () {
              showDescription();
              showBox();
              closeBtn();
              toggleVraiFaux();
              showExtension();
              closeExtension();
              mobilizeView();
              map();
              temoignages();
              temoignagesPrivate();
              temoginagesFilter();
              sensibilize();
              moveFocusToStep2();
              faq();
            }());
          }
        }, 100);
        document.body.setAttribute('data-paragraphs', 'true');
      }

      const dynMap = document.querySelector('.region-carte-dynamique');
      if (context === dynMap) {
        renseignezVous();
      }

      const supportTarget = document.querySelector('.mobilize-your-loved-ones');
      if (context === supportTarget) {
        mobilisezVous();
      }

      const mapWrapper = document.getElementById('location-wrapper');
      if (context === mapWrapper) {
        map();
      }
    }
  };

  function moveFocusToStep2() {
    document.querySelectorAll('label[for="edit-age-limit-oui"]')
      .forEach((label) => {
        const delay = 1000;
        label.previousElementSibling.addEventListener('keydown', (e) => {
          e.stopImmediatePropagation();
          if (e.key === ' ') {
            setTimeout(() => {
              const step2 = document.querySelector('.preregister__step-2');
              step2.focus();
            }, delay);
          }
        });

        label.addEventListener('click', () => {
          setTimeout(() => {
            const step2 = document.querySelector('.preregister__step-2');
            step2.focus();
          }, delay);
        });
      });
  }

  // Check if the video field is checked and display the video link accordingly
  document.addEventListener('change', (e) => {
    if (e.target.name === 'support_target_id') {
      const videoRadio = document.querySelector('input[name="support_target_id"][value="17"]');
      const videoLink = document.querySelector('.support__link-yt');

      if (!videoLink) {
        return;
      }
      if (videoRadio && videoRadio.checked) {
        videoLink.style.display = 'block';
      } else {
        videoLink.style.display = 'none';
      }
    }
  });

  /**
   * Enable the toggle behavior for the mobilize view.
   *
   * @return {void};
   */
  function mobilizeView() {
    document.querySelectorAll('button.mobilize__switch').forEach((button) => {
      togglePanel(button, {
        panel: 'next',
        panelLabel: 'Contenu',
        outsideClose: false,
        autoFocus: false,
      });
    });
  }

  function toggleVraiFaux() {
    // Show.
    document.querySelectorAll('.default-button').forEach((btn) => {
      btn.addEventListener('click', (e) => {
        const answer = e.target.parentElement.nextElementSibling.closest('.close-button-section');
        answer.classList.add('is-active');
        setTimeout(() => {
          answer.classList.add('anim-enter');
        }, 1);

        const delay = 300;
        setTimeout(() => {
          answer.querySelector('button').focus();
        }, delay);
      });
    });

    // Hide.
    const closebtn = document.querySelectorAll('.close-button');
    Array.from(closebtn).forEach((btn) => {
      btn.addEventListener('click', (e) => {
        const answer = e.target.parentElement.closest('.close-button-section');
        answer.classList.remove('anim-enter');

        const delay = 300;
        setTimeout(() => {
          answer.classList.remove('is-active');
          answer.previousElementSibling.querySelector('button').focus();
        }, delay);
      });
    });

    // Show the first question if parameter exists 'reponse'.
    if (getParam('reponse')) {
      document.querySelector('.vrai-ou-faux .default-button').click();
    }
  }

  function box() {
    this.parentElement.nextElementSibling.closest('.bone-marrow-sampling-child__paragraph-item-list').style.display = 'flex';
    this.parentElement.nextElementSibling.closest('.bone-marrow-sampling-child').classList.add('deplier');
  }

  function showBox() {
    const showbtn = document.querySelectorAll('.bone-marrow-sampling-child__bouton button');
    Array.from(showbtn).forEach((btn) => {
      btn.addEventListener('click', box);
      btn.setAttribute('title', `Déplier ${btn.innerText}`);
    });
  }

  function closeBox(e) {
    e.preventDefault();
    this.parentElement.closest('.bone-marrow-sampling-child').querySelector('.bone-marrow-sampling-child__paragraph-item-list').style.display = 'none';
    // this.parentElement.closest('.bone-marrow-sampling-child__paragraph-item-list').style.display = 'none';
    this.parentElement.closest('.bone-marrow-sampling-child').classList.remove('deplier');
    this.focus();

    // remettre l'ancre sur le top du paragraphe lors de la fermeture du pavé déployé
    let anchorId = '#anchor-bone-marrow-sample';
    anchorId = anchorId.substring(1, anchorId.length);
    if (anchorId) {
      const headerOffset = 200;
      const anchor = document.getElementById(anchorId);
      const bodyRect = document.body.getBoundingClientRect().top;
      const anchorOffset =  anchor.getBoundingClientRect().top - bodyRect - headerOffset;
      window.scroll({
        top: anchorOffset,
        left: 0,
        behavior: 'smooth',
      });
    }
  }

  function closeBtn() {
    const closebtn = document.querySelectorAll('.close-box');
    Array.from(closebtn).forEach((btn) => {
      btn.addEventListener('click', closeBox);
    });
  }

  function showExtension() {
    const showbtn = document.querySelector('.great-standard__bouton');

    const extension = document.querySelector('.great-standard-extension');
    // Sans bouton « great standard » pour l'ouvrir, le panneau reste affiché
    // (le masquer le rendrait inaccessible) ; une erreur ici bloquait aussi la
    // suite des scripts de la page.
    if (!extension || !showbtn) {
      return;
    }
    const searchSection = document.querySelector('.search-svg-section');

    extension.style.display = 'none';
    showbtn.addEventListener('click', () => {
      if (extension.style.display === 'none') {
        extension.style.display = 'flex';
        if (searchSection) {
          searchSection.style.display = 'none';
        }
        showbtn.classList.add('clic-on');
      } else {
        extension.style.display = 'none';
        if (searchSection) {
          searchSection.style.display = 'flex';
        }
        showbtn.classList.remove('clic-on');
      }
    });
  }

  function closeExtension() {
    const showbtn = document.querySelector('.great-standard-extension .close-button');
    if (!showbtn) {
      return;
    }

    showbtn.addEventListener('click', () => {
      document.querySelector('.great-standard-extension').style.display = 'none';
      const searchSection = document.querySelector('.search-svg-section');
      if (searchSection) {
        searchSection.style.display = 'flex';
      }
    });
  }

  function showDescription() {
    const showbtn = document.querySelectorAll('.show-more-button');

    [].forEach.call(showbtn, (e) => {
      togglePanel(e, {
        panel: 'next',
        panelLabel: 'Réponse',
        outsideClose: false,
      });
    });
  }

  /**
   * Fill the region selection from clicking in the map.
   *
   * @return {void};
   */
  function map() {
    const SvgMap = document.querySelector('.region-carte-dynamique__map .map__map .svg-map');
    if (!SvgMap) {
      return;
    }

    const mapLinkList = SvgMap.querySelectorAll('a');
    [].forEach.call(mapLinkList, (link) => {
      link.addEventListener('click', (e) => {
        e.preventDefault();
        // Select the related option.
        const optionToSelect = document.querySelector(`#edit-region-value [value="${link.dataset.region}"]`);
        if (optionToSelect) {
          optionToSelect.selected = true;
        }

        // Submit the form.
        document.querySelector('.region-carte-dynamique .views-exposed-form').submit();
      });
    });

    // Highlight the region.
    const regionArg = getParam('region_value');
    if (regionArg && regionArg !== 'All') {
      SvgMap.classList.add('map--has-selection');
      SvgMap
        .querySelector(`[data-region="${regionArg}"]`)
        .classList.add('region--is-selected');
    }
  }

  function renseignezVous() {
    // Hide the second button if there no sorting selected.
    const firstSort = document.querySelector('.form__item-sort-bef-combine:first-child');
    const sortArg = getParam('sort_bef_combine');
    const locationCenter = document.querySelector('[id^="edit-location-type-value-centre"]');
    const locationAssociation = document.querySelector('[id^="edit-location-type-value-association"]');
    if (firstSort && !sortArg) {
      firstSort.classList.add('is-hidden');
    }

    if (sortArg || getParam('region_value') || getParam('support_target_id') || getParam('theme')) {
      const tabs = document.querySelector('#edit-location-type-value--wrapper, #views-exposed-form-mobilize-your-loved-ones-promoted, #views-exposed-form-faq-questions-faq-questions');

      if (tabs && getParam('department_value') !== 'All') {
        const scrollOffset = 200;

        // Smooth.
        if (!getParam('home')) {
          window.scroll({
            top: tabs.getBoundingClientRect().top - scrollOffset,
            left: 0,
            behavior: 'smooth',
          });
        }
      }
    }

    if (locationCenter) {
      if (locationCenter.checked) {
        locationCenter.nextElementSibling.classList.add('is-checked');
      } else {
        locationAssociation.nextElementSibling.classList.add('is-checked');
      }
    }
  }

  function mobilisezVous() {
    if (getParam('support_target_id')) {
      const tabs = document.querySelector('#views-exposed-form-mobilize-your-loved-ones-promoted');
      if (tabs && getParam('support_target_id') !== 'All') {
        const scrollOffset = 200;

        // Smooth.
        if (!getParam('home')) {
          window.scroll({
            top: tabs.getBoundingClientRect().top - scrollOffset,
            left: 0,
            behavior: 'smooth',
          });
        }
      }
    }
  }

  function faq() {
    const faqElement = document.querySelector('.faq-questions, .faq-questions-mobile');
    if (!faqElement) {
      return;
    }

    // Initialise les submit sur les tab FAQ Public
    const elemTab = document.querySelector('#views-exposed-form-faq-questions-faq-questions');
    if (elemTab) {
      faqInitTab(elemTab);
    }

    // Initialise les submit sur les select FAQ Public
    const elemSelect = document.querySelector('#views-exposed-form-faq-questions-faq-questions-mobile');
    if (elemSelect) {
      faqInitSelect(elemSelect);
    }

    // Initialise les submit sur les tab FAQ Privée
    const elemPrivateTab = document.querySelector('#views-exposed-form-faq-questions-private-faq-questions');
    if (elemPrivateTab) {
      faqInitTab(elemPrivateTab);
    }

    // Initialise les submit sur les select FAQ Privée
    const elemPrivateSelect = document.querySelector('#views-exposed-form-faq-questions-private-faq-questions-mobile');
    if (elemPrivateSelect) {
      faqInitSelect(elemPrivateSelect);
    }
    //

    if (getParam('theme')) {
      const tabs = document.querySelector('#views-exposed-form-faq-questions-faq-questions, #views-exposed-form-faq-questions-faq-questions-mobile, #views-exposed-form-faq-questions-private-faq-questions, #views-exposed-form-faq-questions-private-faq-questions-mobile');
      if (tabs && getParam('theme') !== 'All') {
        const scrollOffset = 200;

        // Smooth.
        if (!getParam('home')) {
          window.scroll({
            top: tabs.getBoundingClientRect().top - scrollOffset,
            left: 0,
            behavior: 'smooth',
          });
        }
      }
    }
  }

  /**
   * Soumet le changement de rubrique.
   *
   * Sur la page dédiée d'une question (DVMO-221), la rubrique choisie
   * s'affiche sur la page thématique de la FAQ, pas sur l'URL de la question.
   *
   * @param {HTMLFormElement} elem
   *   Le formulaire des rubriques.
   *
   * @return {void}
   */
  function faqSubmitTheme(elem) {
    if (drupalSettings.ddmoFaq && drupalSettings.ddmoFaq.themesUrl) {
      elem.setAttribute('action', drupalSettings.ddmoFaq.themesUrl);
    }
    elem.submit();
  }

  function faqInitTab(elem) {
    const selectedtab = elem.querySelectorAll('.form__radio-list .form-radios');
    if (selectedtab) {
      selectedtab.forEach((div) => {
        div.addEventListener('change', (e) => {
          faqSubmitTheme(elem);
        });
      });
    }
  }

  function faqInitSelect(elem) {
    const selectedoption = elem.querySelectorAll('.multiple-user-tabs__menu .multiple-user-tabs__options li');
    if (selectedoption) {
      selectedoption.forEach((li) => {
        li.addEventListener('click', (e) => {
          faqSubmitTheme(elem);
        });
      });
    }
  }

  /**
   * Show just a part of tTxt.
   *
   * @return {void}
   */
  function showMore() {
    // Delegated event.
    document.addEventListener('click', (e) => {
      if (e.target.matches('.show-more-link')) {
        const fields = e.target.parentNode.querySelectorAll('.view-events__body, .view-event__link, .show-more-link');
        fields.forEach((el) => {
          el.classList.toggle('is-hidden');
        });
        if ($('.multiple-events-tabs').length > 0) {
          // Seulement si le carrousel est initialisé (sinon erreur Slick).
          $('.multiple-events-tabs__events-tabs-item-list.slick-initialized')
            .slick('setPosition');
        }
      }
    }, false);
  }

  function temoignages() {
    // Sicky filter.
    // @see https://abouolia.github.io/sticky-sidebar/
    const filterBar = document.getElementById('filter-bar');
    if (!filterBar) {
      return;
    }

    const header = document.querySelector('.header__nav');
    const headerHeight = header.getBoundingClientRect().height;
    const sidebar = new StickySidebar('#filter-bar-public', {
      containerSelector: '.testimonials-display',
      innerWrapperSelector: '.filter-bar__inner',
      topSpacing: headerHeight,
    });

    // Filters for small screens.
    if (matchMedia('(max-width: 767px)').matches) {
      const filterForm = document.getElementById('views-exposed-form-testimonials-display-testimonials-display');
      const filterTitle = document.querySelector('.filter-bar .fieldset__title');
      filterTitle.addEventListener('click', (e) => {
        filterForm.classList.toggle('filters-are-visible');
      });
    }
  }

  function temoignagesPrivate() {
    // Sicky filter.
    // @see https://abouolia.github.io/sticky-sidebar/
    const filterBar = document.getElementById('filter-bar');
    if (!filterBar) {
      return;
    }

    const header = document.querySelector('.header__nav');
    // const headerHeight = header.getBoundingClientRect().height;
    const sidebar = new StickySidebar('#filter-bar', {
      containerSelector: '.testimonials-display',
      innerWrapperSelector: '.filter-bar__inner',
      topSpacing: '250px',
    });

    // Filters for small screens.
    if (matchMedia('(max-width: 767px)').matches) {
      const filterForm = document.getElementById('views-exposed-form-testimonies-private-display-testimonies-private-display');
      const filterTitle = document.querySelector('.filter-bar .fieldset__title');
      filterTitle.addEventListener('click', (e) => {
        filterForm.classList.toggle('filters-are-visible');
      });
    }
  }

  function temoginagesFilter() {
    const selectedfilter = document.querySelector('.filter-bar input:checked');
    if (!selectedfilter) {
      return;
    }
    selectedfilter.addEventListener('click', () => {
      window.location = document.body.getAttribute('data-url');
    });
  }

  function sensibilize() {
    const switchList = document.querySelectorAll('.awareness__switch');
    switchList.forEach((button) => {
      button.addEventListener('click', () => {
        button.parentNode.classList.toggle('awareness__step--is-active');
      });
    });
  }
}(Drupal, drupalSettings, jQuery));
